import React from 'react';
import styled from 'styled-components';

// Styled component for the Flex container
const FlexContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  flex-wrap: ${(props) => (props.wrapi ? 'wrap' : 'nowrap')};
  justify-content: ${(props) => props.justifycontent || 'flex-start'};
  align-items: ${(props) => props.alignitems || 'stretch'};
  gap: ${(props) => props.gap || '0'};
  
`;

const Flex = ({
  children,
  gap = '20px',
  wrap = true,
  justifyContent = 'center',
  alignItems = 'center',
  direction = 'row',
  ...props
}) => {
  return (
    <FlexContainer
      gap={gap}
      wrapi={wrap}
      justifycontent={justifyContent}
      alignitems={alignItems}
      direction={direction}
      {...props}
    >
      {children}
    </FlexContainer>
  );
};

export default Flex;
